import styled from "styled-components";

export const FormContainer = styled("div")`
  #root_property {
    width: 250px;
  }
  label.control-label[for="root_property"] {
    display: block;
    width: 100%;
    padding: 0;
    margin: 4px 0 4px 0;
    font-size: 18px;
    line-height: inherit;
    color: #3a3f51;
    border: 0;
  }
`;
export const StyledSelect = styled.select`
  max-width: 300px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #c3c3c3;
  background: #fff;
  font-size: 14px;
  min-width: 200px;
  margin-top: 4px;
  margin-bottom: 4px;
`;
